// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".google-captcha-policy[data-v-59f653f3]{margin-bottom:21px;font-weight:500}.google-captcha-policy a[data-v-59f653f3]{color:#8c4ddf;text-decoration:none}", ""]);
// Exports
module.exports = exports;
